import {HttpClient} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import {ConfigurationService} from './configuration.service';
import {Settings} from './settings';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private readonly http = inject(HttpClient);
  private readonly configurationService = inject(ConfigurationService);

  private settings: Map<string, string> = new Map<string, string>();

  public get(key: string): string | undefined {
    return this.settings.get(key);
  }

  public getInteger(key: string, defaultValue: number): number {
    let value = Number(this.get(key));
    return Number.isInteger(value) ? value : defaultValue;
  }

  public initSettings(): Promise<any> {
    const config = this.configurationService.getConfig();
    return firstValueFrom(
      this.http.get<Settings[]>(`${config.backendUrl}/settings`)
        .pipe(
          map((data: Settings[]) => new Map(data.map(it => [it.key, it.value]))),
          tap(settings => this.settings = settings)
        )
    );
  }
}
